import i18n from 'locales/i18n';

type Param = string;

export const tF = (param: Param, options?: Record<string, string>) =>
	(() => i18n?.t(param, options)) as () => string;
